import ResizableDrawer from "components/material/resizable-drawer"
import { useAnalytics } from "connected-components/analytics"
import PreferenceContext from "hooks/preferences"
import PropTypes from "prop-types"
import { useEffect, useMemo, useRef } from "react"
import { useAccountId } from "resources/account"
import { AI_TEAMMATE_EVENTS, AiTeammateAnalyticsProvider } from "./analytics"
import AiTeammateHeader from "./components/header"
import AiTeammateThread from "./components/thread"
import AiTeammateThreadsList from "./components/threads-list"
import { AiTeammateProvider } from "./context"
import { MessagesProvider } from "./context/messages"
import { ThreadsProvider } from "./context/threads"
import { useAiTeammateContext, useThreadsContext } from "./hooks/context"
import "./style.scss"

export default function AiTeammateWrapper(props) {
  const accountId = useAccountId()

  const preferencesProps = useMemo(() => ({
    accountId,
    key: "ai-teammate",
    type: "ai-teammate",
  }), [accountId])

  return <PreferenceContext.Provider value={preferencesProps}>
    <AiTeammateProvider {...props}>
      <ThreadsProvider>
        <AiTeammateAnalyticsProvider>
          <MessagesProvider initialPrompt={props.initialPrompt}>
            <AiTeammate />
          </MessagesProvider>
        </AiTeammateAnalyticsProvider>
      </ThreadsProvider>
    </AiTeammateProvider>
  </PreferenceContext.Provider>
}

AiTeammateWrapper.propTypes = {
  initialPrompt: PropTypes.string,
}

function AiTeammate() {
  const {
    isOpen,
    onClose,
    drawerWidth,
    isPreferencesLoaded,
    setDrawerWidth,
    setIsDrawerResizing,
  } = useAiTeammateContext()
  const { isThreadOpen, isPreferencesLoaded: isThreadsPreferencesLoaded } = useThreadsContext()
  const analytics = useAnalytics()

  const isOpenRef = useRef(isOpen)

  useEffect(() => {
    if (isOpen && !isOpenRef.current) {
      analytics.track(AI_TEAMMATE_EVENTS.DRAWER_OPENED)
    } else if (!isOpen && isOpenRef.current) {
      analytics.track(AI_TEAMMATE_EVENTS.DRAWER_CLOSED)
    }
    isOpenRef.current = isOpen
  }, [isOpen, analytics])

  const container = useRef(null)

  // Wait until the preferences are loaded to avoid flickering
  if (!isPreferencesLoaded || !isThreadsPreferencesLoaded) {
    return null
  }

  return <span className="connected-components_ai-teammate" ref={container}>
    <ResizableDrawer initialWidth={drawerWidth || "25%"} open={isOpen} onClose={onClose} onResize={setDrawerWidth} onDraggingChange={setIsDrawerResizing} closeOnBackdropClick>
      <div className="ai-teammate-container">
        <AiTeammateHeader onClose={onClose} />
        {isThreadOpen ? <AiTeammateThread /> : <AiTeammateThreadsList />}
      </div>
    </ResizableDrawer>
  </span>
}
